import { ReactNode } from "react";
import { cn } from "../lib/utils";
import { Icon } from "../primitives";
import { BaseComponentProps } from "../types";
import { baseAttrs } from "../utils";

type NotificationCardProps = BaseComponentProps & {
	type: "action" | "pending";
	text: string;
	right?: ReactNode;
};

/**
 * @deprecated Use `<Banner tone="notification">` from `@portal/components/primitives/Banner`
 * instead. Part of the card consolidation.
 */
export const NotificationCard = ({ testId, type, text, right }: NotificationCardProps) => (
	<div
		{...baseAttrs({
			testId,
			className: cn(
				"w-full flex items-center space-y-[10px] justify-between border rounded-sm pl-[15px] pr-[10px] py-[10px] text-[14px] text-gray-800 font-medium",
				type === "action" && "border-intent-warning-border bg-intent-warning-bg",
				type === "pending" && "border-gray-400/25 bg-gray-400/15",
			),
		})}
	>
		<div className="flex-1 flex items-center space-x-[10px]">
			{type === "action" && (
				<>
					<Icon type="exclamation-triangle" size="small" color="warning" className="mt-[1px]" />
					<span>
						Action Required:
						<span className="pl-[8px] w-full text-[14px] text-secondary">{text}</span>
					</span>
				</>
			)}
			{type === "pending" && (
				<>
					<Icon type="clock" color="secondary" size="small" className="overflow-visible ml-[3px]" />
					<span className="pl-[8px] w-full text-[14px] text-secondary">{text}</span>
				</>
			)}
		</div>
		{right && right}
	</div>
);
